import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CartouchesService } from '../../../services/cartouches.service';

export interface CartoucheRetardItem {
  id: number;
  nom: string;
  date_creation: string | null;
  capteur_id: number;
  capteur_numero_serie: string;
  date_envoi: string | null;
  statut_livraison_nom: string | null;
}

@Component({
  selector: 'app-retard-livraison-cartouches-taches',
  imports: [CommonModule, RouterLink],
  templateUrl: './retard-livraison-cartouches-taches.component.html',
  styleUrl: './retard-livraison-cartouches-taches.component.scss'
})
export class RetardLivraisonCartouchesTachesComponent implements OnInit {
  protected loading = false;
  protected error = '';
  protected items: CartoucheRetardItem[] = [];

  constructor(
    private readonly cartouchesService: CartouchesService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.load();
  }

  protected refresh(): void {
    this.load();
  }

  private load(): void {
    this.loading = true;
    this.error = '';
    this.cdr.markForCheck();

    this.cartouchesService.listRetardsCartouches().subscribe({
      next: (items: CartoucheRetardItem[]) => {
        this.items = items;
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: (err: HttpErrorResponse) => {
        this.items = [];
        this.error = this.getErrorMessage(err);
        this.loading = false;
        this.cdr.markForCheck();
      }
    });
  }

  private getErrorMessage(err: HttpErrorResponse): string {
    if (typeof err.error === 'string' && err.error.trim()) {
      return err.error;
    }
    if (err.error?.detail) {
      return String(err.error.detail);
    }
    if (err.error?.message) {
      return String(err.error.message);
    }
    return err.statusText || 'Erreur inconnue';
  }
}
